import { render, staticRenderFns } from "./view-info.vue?vue&type=template&id=7071470e&"
import script from "./view-info.vue?vue&type=script&lang=ts&"
export * from "./view-info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports